import PasswordReset from "../../components/cm/Dashboard/FullPages/ClientForm/PasswordReset";

export default () => {
  return <PasswordReset />;
};
